import Branch from '../interfaces/Branch'

import { SelectField } from './SelectField'

// Reusable Select Field Component para el Branch
const SelectBranchField: React.FC<{
  label: string
  name: string
  value?: string
  options: Branch[] | undefined
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void
  errors?: { [key: string]: string }
  firstOptionText?: string
}> = ({ label, name, value, options, handleInputChange, errors, firstOptionText }) => {
  // Convert array to record
  const optionsRecord: Record<string, string> = (options ?? []).reduce(
    (acc, option) => {
      acc[option._id] = option.name

      return acc
    },
    {} as Record<string, string>
  )

  return (
    <SelectField
      label={label}
      name={name}
      value={value}
      options={optionsRecord}
      handleInputChange={handleInputChange}
      errors={errors}
      firstOptionText={firstOptionText}
    />
  )
}
export default SelectBranchField
